/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAirport } from './PaxCheckAirport';
import {
    PaxCheckAirportFromJSON,
    PaxCheckAirportFromJSONTyped,
    PaxCheckAirportToJSON,
    PaxCheckAirportToJSONTyped,
} from './PaxCheckAirport';

/**
 * Transit point - API output
 * @export
 * @interface PaxCheckTransitPoint
 */
export interface PaxCheckTransitPoint {
    /**
     * 
     * @type {PaxCheckAirport}
     * @memberof PaxCheckTransitPoint
     */
    airport: PaxCheckAirport;
    /**
     * Date and time of departure (local)
     * @type {string}
     * @memberof PaxCheckTransitPoint
     */
    departureDatetime: string;
    /**
     * Date and time of arrival (local)
     * @type {string}
     * @memberof PaxCheckTransitPoint
     */
    arrivalDatetime: string;
    /**
     * ISO 3166-1 alpha-3 country code
     * @type {string}
     * @memberof PaxCheckTransitPoint
     */
    countryCode: string;
}

/**
 * Check if a given object implements the PaxCheckTransitPoint interface.
 */
export function instanceOfPaxCheckTransitPoint(value: object): value is PaxCheckTransitPoint {
    if (!('airport' in value) || value['airport'] === undefined) return false;
    if (!('departureDatetime' in value) || value['departureDatetime'] === undefined) return false;
    if (!('arrivalDatetime' in value) || value['arrivalDatetime'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function PaxCheckTransitPointFromJSON(json: any): PaxCheckTransitPoint {
    return PaxCheckTransitPointFromJSONTyped(json, false);
}

export function PaxCheckTransitPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckTransitPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'airport': PaxCheckAirportFromJSON(json['airport']),
        'departureDatetime': json['departure_datetime'],
        'arrivalDatetime': json['arrival_datetime'],
        'countryCode': json['country_code'],
    };
}

export function PaxCheckTransitPointToJSON(json: any): PaxCheckTransitPoint {
    return PaxCheckTransitPointToJSONTyped(json, false);
}

export function PaxCheckTransitPointToJSONTyped(value?: PaxCheckTransitPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airport': PaxCheckAirportToJSON(value['airport']),
        'departure_datetime': value['departureDatetime'],
        'arrival_datetime': value['arrivalDatetime'],
        'country_code': value['countryCode'],
    };
}

